import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/Home-Interiors2.jpg';
import { Helmet } from 'react-helmet';

const Homeinteriors = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (

         <>
      <Helmet>
        <title>Home Interiors</title>
        <meta name="description" content="Beautiful Homes Start with Thoughtful Design" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Home Interiors</h1>
                                <h6>Beautiful Homes Start with Thoughtful Design</h6>
                                <p>Looking to build your dream home interior in Bengaluru? YATRI INTERIORS brings you personalized and fully functional
                                 home interior solutions that combine comfort, aesthetics, and smart utility.
                                </p>
                                <h4>We specialize in:</h4>
                                <ul>
                                    <li>Modular kitchen design and installation</li>
                                    <li>Wardrobes, TV units, and storage solutions</li>
                                    <li>Bedroom, living room, and dining area design</li>
                                    <li>False ceiling and lighting layout</li>
                                    <li>Color-coordinated painting and finish work</li>
                                    <p>Transform your home into a sanctuary of style and comfort with our expert design & execution team.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Homeinteriors;